import React from 'react'
import classnames from 'classnames'
import Img from 'gatsby-image'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import { fragStudy } from '../../utils/fragments'
import { mapStudy, mapMetaData } from '../../utils/mapper'

import MetaData from '../../components/metadata'
import Poster from '../../components/poster'
import Lead from '../../components/lead'
import Quote from '../../components/quote'
import Section from '../../components/section'
import EndPiece from '../../components/endpiece'
import Footer from '../../components/footer'

import { CONTENTTYPES } from '../../utils/constants'

import styles from '../../styles/site'

const Study = props => {
  const { classes } = props
  const metadata = mapMetaData(props.data.study)
  const study = mapStudy(props.data.study)

  return (
    <div>
      <MetaData data={metadata} />
      <Poster
        image={study.image}
        urls={study.video_bg.urls}
        poster={study.video_bg.poster}
      />
      <div className={classes.mainFloat}>
        <Lead
          title={study.title}
          author={study.author}
          published={study.published}
          lead={study.lead}
          path={props.location.pathname}
          tags={study.tags}
        />
        {study.contents &&
          study.contents.map((content, index) => {
            switch (content.type) {
              case CONTENTTYPES.section:
                return <Section key={index} section={content} />
              case CONTENTTYPES.quote:
                return <Quote key={index} quote={content} />
            }
          })}
        <EndPiece author={study.author} published={study.published} />
        <div className={classes.studyEnd} />
      </div>
      <Footer policies={props.data.policies.edges} />
    </div>
  )
}

export default withStyles(styles)(Study)

export const query = graphql`
  query postStudy($id: String!) {
    study: prismicCtStudy(id: { eq: $id }) {
      ...study
    }

    policies: allPrismicCtDoc {
      edges {
        node {
          uid
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/studies/study.js